import { makeStyles } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
  apartmentInfoWrapper: {
    display: 'flex',
  },
  apartmentIcon: {
    fontSize: '56px',
    color: theme.palette.grey.A100,
  },
  resolutionTitle: {
    borderBottom: `2px solid ${theme.palette.grey.A100}`,
  },
  resolutionResult: {
    borderTop: `1px dotted ${theme.palette.primary.main}`,
    borderBottom: `1px dotted ${theme.palette.primary.main}`,
    textAlign: 'center',
    padding: '4px 0',
    marginTop: '0.35em',
  },
  noLineHeight: {
    lineHeight: '1',
  },
  withMargin: {
    margin: '5mm 12mm',
    // marginLeft: `20px`,
    // marginTop: `20px`,
    // marginRight: '20px',
  },
}))
export const customTheme = (fontSize = 12) => {
  return createTheme({
    overrides: {
      body: {
        root: {
          backgroundColor: 'blue',
        },
      },
    },
    palette: {
      primary: {
        main: '#143A5F',
        contrastText: '#ffffff',
      },
    },
    typography: {
      fontFamily: 'Helvetica',
      fontSize: fontSize,
    },
  })
}
export default useStyles
